const StationPositionEnum = {
  CASHIER: "cashier",
  STATION_HEAD: "station-head",
  SERVICE_ADVISOR: "service-advisor",
  TECHNICIAN: "technician",
};

export default StationPositionEnum;
